import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DrawerBodyWrapper, DrawerFooterWrapper } from '@base'
import { CRAN_SECTION_TYPES } from '@constants'
import { getCranReportById } from '@data/conn/get/cranReport'
import { addCommentInCranReport } from '@data/conn/post/cranReport'
import { showLoader } from '@data/state/action'
import { useForceUpdate } from '@hooks'
import { InputWrapper } from '../styles'
import ProbeTextArea from '../Components/ProbeTextArea'

const dataToForm = (prevState, data) => {
	if (data === null) {
		return prevState
	}
	let _obj = data?.slice(-1)?.[0]
	return {
		...prevState,
		value: _obj?.comment,
		show_in_cran: _obj?.show_in_cran,
		comment_type: _obj?.comment_type,
		dirty: true,
	}
}

const deriveFormState = (data) => {
	const _state = {
		legal_history: {
			label: 'Legal History',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		bifr_history: {
			label: 'BIFR History',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		cdr_history: {
			label: 'Corporate Dept Restructuring (CDR) History',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		defaulters: {
			label: 'Suit Filed Cases as per Bureau',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		delays: {
			label: 'MSME Supplier Payment Delay',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		financial_disputes: {
			label: 'Legal Case of Financial Disputes',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		gst_filings: {
			label: 'GST Filing History',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
		epfo_filings: {
			label: 'EPFO Filings',
			placeholder: 'Enter comments here...',
			value: '',
			show_in_cran: false,
			comment_type: null,
			disabled: false,
			dirty: false,
		},
	}

	if (data) {
		_state.legal_history = dataToForm(_state.legal_history, data?.legal_history)
		_state.bifr_history = dataToForm(_state.bifr_history, data?.bifr_history)
		_state.cdr_history = dataToForm(_state.cdr_history, data?.cdr_history)
		_state.defaulters = dataToForm(_state.defaulters, data?.defaulters)
		_state.delays = dataToForm(_state.delays, data?.delays)
		_state.financial_disputes = dataToForm(_state.financial_disputes, data?.financial_disputes)
		_state.gst_filings = dataToForm(_state.gst_filings, data?.gst_filings)
		_state.epfo_filings = dataToForm(_state.epfo_filings, data?.epfo_filings)
	}

	return _state
}

const ComplianceForm = ({ probeId }) => {
	const dispatch = useDispatch()
	const [formState, setFormState] = useState(deriveFormState())
	const loggedInUser = useSelector((state) => state.getIn(['user', 'user']))
	const [forceUpdate, update] = useForceUpdate()

	useEffect(() => {
		dispatch(showLoader(true))
		getCranReportById(probeId, [CRAN_SECTION_TYPES.COMPLIANCE])
			.then((response) => {
				setFormState(deriveFormState(response))
			})
			.catch((error) => {
				console.log(error)
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}, [forceUpdate])

	const updateState = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				value: value,
			},
		}))
	}

	const updateCheckHandler = (key) => (val) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				show_in_cran: val,
			},
		}))
	}

	const commentTypeHandler = (key) => (value) => {
		setFormState((_s) => ({
			..._s,
			[key]: {
				..._s[key],
				comment_type: value,
			},
		}))
	}

	const addHandler = (key) => () => {
		let obj = formState[key]
		let comment = {
			comment: obj.value,
			comment_type: obj.comment_type,
			created_by: loggedInUser?.user_id,
			show_in_cran: obj?.show_in_cran,
			// created_at: new Date().getTime(),
		}
		dispatch(showLoader(true))
		addCommentInCranReport({
			userId: loggedInUser?.user_id,
			commentValue: comment,
			commentKey: key,
			probe42Id: probeId,
		})
			.then((response) => {})
			.catch((error) => {})
			.finally(() => {
				update()
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.legal_history?.label}
						placeholder={formState?.legal_history?.placeholder}
						toggleState={formState?.legal_history?.comment_type}
						textValue={formState?.legal_history?.value}
						onTextChange={updateState('legal_history')}
						onCheckHandler={updateCheckHandler('legal_history')}
						checkValue={formState?.legal_history?.show_in_cran}
						onToggleChange={commentTypeHandler('legal_history')}
						onButtonClick={addHandler('legal_history')}
						disabled={formState?.legal_history?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.bifr_history?.label}
						placeholder={formState?.bifr_history?.placeholder}
						toggleState={formState?.bifr_history?.comment_type}
						textValue={formState?.bifr_history?.value}
						onTextChange={updateState('bifr_history')}
						onCheckHandler={updateCheckHandler('bifr_history')}
						checkValue={formState?.bifr_history?.show_in_cran}
						onToggleChange={commentTypeHandler('bifr_history')}
						onButtonClick={addHandler('bifr_history')}
						disabled={formState?.bifr_history?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.cdr_history?.label}
						placeholder={formState?.cdr_history?.placeholder}
						toggleState={formState?.cdr_history?.comment_type}
						textValue={formState?.cdr_history?.value}
						onTextChange={updateState('cdr_history')}
						onCheckHandler={updateCheckHandler('cdr_history')}
						checkValue={formState?.cdr_history?.show_in_cran}
						onToggleChange={commentTypeHandler('cdr_history')}
						onButtonClick={addHandler('cdr_history')}
						disabled={formState?.cdr_history?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.defaulters?.label}
						placeholder={formState?.defaulters?.placeholder}
						toggleState={formState?.defaulters?.comment_type}
						textValue={formState?.defaulters?.value}
						onTextChange={updateState('defaulters')}
						onCheckHandler={updateCheckHandler('defaulters')}
						checkValue={formState?.defaulters?.show_in_cran}
						onToggleChange={commentTypeHandler('defaulters')}
						onButtonClick={addHandler('defaulters')}
						disabled={formState?.defaulters?.disabled}
					/>
				</InputWrapper>

				<InputWrapper>
					<ProbeTextArea
						label={formState?.delays?.label}
						placeholder={formState?.delays?.placeholder}
						toggleState={formState?.delays?.comment_type}
						textValue={formState?.delays?.value}
						onTextChange={updateState('delays')}
						onCheckHandler={updateCheckHandler('delays')}
						checkValue={formState?.delays?.show_in_cran}
						onToggleChange={commentTypeHandler('delays')}
						onButtonClick={addHandler('delays')}
						disabled={formState?.delays?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.financial_disputes?.label}
						placeholder={formState?.financial_disputes?.placeholder}
						toggleState={formState?.financial_disputes?.comment_type}
						textValue={formState?.financial_disputes?.value}
						onTextChange={updateState('financial_disputes')}
						onCheckHandler={updateCheckHandler('financial_disputes')}
						checkValue={formState?.financial_disputes?.show_in_cran}
						onToggleChange={commentTypeHandler('financial_disputes')}
						onButtonClick={addHandler('financial_disputes')}
						disabled={formState?.financial_disputes?.disabled}
					/>
				</InputWrapper>

				<InputWrapper>
					<ProbeTextArea
						label={formState?.gst_filings?.label}
						placeholder={formState?.gst_filings?.placeholder}
						toggleState={formState?.gst_filings?.comment_type}
						textValue={formState?.gst_filings?.value}
						onTextChange={updateState('gst_filings')}
						onCheckHandler={updateCheckHandler('gst_filings')}
						checkValue={formState?.gst_filings?.show_in_cran}
						onToggleChange={commentTypeHandler('gst_filings')}
						onButtonClick={addHandler('gst_filings')}
						disabled={formState?.gst_filings?.disabled}
					/>
				</InputWrapper>
				<InputWrapper>
					<ProbeTextArea
						label={formState?.epfo_filings?.label}
						placeholder={formState?.epfo_filings?.placeholder}
						toggleState={formState?.epfo_filings?.comment_type}
						textValue={formState?.epfo_filings?.value}
						onTextChange={updateState('epfo_filings')}
						onCheckHandler={updateCheckHandler('epfo_filings')}
						checkValue={formState?.epfo_filings?.show_in_cran}
						onToggleChange={commentTypeHandler('epfo_filings')}
						onButtonClick={addHandler('epfo_filings')}
						disabled={formState?.epfo_filings?.disabled}
					/>
				</InputWrapper>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper></DrawerFooterWrapper>
		</>
	)
}

export default ComplianceForm
